import(/* webpackMode: "eager" */ "/home/coder/pubky-app-preview/src/app/global-error.tsx");
